<app-pcbread-crumb [data]="breadCrumb"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcedit-modal
  [modalIsOpen]="openAddModal"
  [inputFields]="modalFields"
  [editSource]="thisValue"
  (parentAction)="parentAction($event)"
>
</app-pcedit-modal>

<app-pcsuccess-modal
  [showModal]="modalSuccessConfirm"
  (parentAction)="parentAction($event)"
>
</app-pcsuccess-modal>

<app-pcsetting-modal (parentAction)="parentAction($event)" [fields]="fields">
</app-pcsetting-modal>

<ng-template #modalContent let-modal>
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "PhoneNumber" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close close-modal-button text-reset"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body mx-0 flex-grow-0">
    <div class="row modal-body-form ">
      <ng-container *ngFor="let item of phoneList">
        <div class="col-12 box-phone-number my-1 py-2">
          <div class="row">
            <div
              class="col-3 d-flex justify-content-center align-items-center ps-4"
            >
              <p class="m-0">
                {{ item.phoneNumber }}
              </p>
            </div>
            <div
              class="col-9 d-flex justify-content-center align-items-center"
            >
              <p class="m-0">
                {{ item.comment }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>

      <div class="col-5 mb-3">
        <div class="edit-form">
          <label class="form-label">
            {{ "Number" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newPhone.phoneNumber"
            [ngModelOptions]="{ standalone: true }"
            placeholder="09xx xxx xxxx"
          />
        </div>
      </div>

      <div class="col-6 mb-3">
        <div class="edit-form">
          <label class="form-label">
            {{ "Comment" | translate }}
          </label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newPhone.comment"
            [ngModelOptions]="{ standalone: true }"
            [attr.placeholder]="'comment' | translate"
          />
        </div>
      </div>

      <div class="col-1 mb-3">
        <div class="d-flex align-items-end h-100 pb-2">
          <button
            type="button"
            class="btn btn-icon btn-primary"
            (click)="createPhoneBook()"
          >
            <i class="far fa-save"></i>
          </button>
        </div>
      </div>
    </div>

    <app-loading-panel *ngIf="modalLoading"></app-loading-panel>
  </div>
  <div class="modal-footer border-top p-3">
    <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit">
      {{ "Submit" | translate }}
    </button>
    <button
      type="reset"
      class="btn btn-label-secondary"
      (click)="modal.dismiss('Cross click')"
    >
      {{ "Cancel" | translate }}
    </button>
  </div>
</ng-template>
